import { render, staticRenderFns } from "./CropStatistics.vue?vue&type=template&id=292fd6f8&"
import script from "./CropStatistics.vue?vue&type=script&lang=js&"
export * from "./CropStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports